export default "__VITE_ASSET__c36ec286__"